module.exports = __webpack_public_path__ + "static/media/motion_track.bb008842.svg";